import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import { IconButton } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getLTViewerHideColumnsEndpoint, getViewAllDetailsEndpoint, postLTViewerHideColumnsEndpoint, viewerWorkflowCountEndpoint } from "../../../common/endpoints";
import Cards from "../../../components/common/card/Card";
import DataTable from "../../../components/common/datatable/DataTable";
import { Loader } from "../../../components/common/Loader";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import TopSection from "../TopSection";
import "./AnalyticsResults.css";
import LeadtimeModel from "./LeadTimeModal";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Badge, Box, Checkbox, CircularProgress, ListItemText, MenuItem, Popover, Select } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import ButtonComponent from "../../../components/common/button/Button";
import { getViewerHideColumnsAPI } from "../../../redux/actions/HideColumns/GetViewerHideColumns";
import { postViewerHideColumnsAPI } from "../../../redux/actions/HideColumns/PostViewerHideColumns";
import { getViewerWorkFlowCountSlice } from "../../../redux/actions/ViewerScreen/GetViewerWorkflowCountSlice";
import { getViewerAnalyticsWorkflowResults } from "../../../redux/actions/ViewerScreen/ViewerAnalyticsWorkflowResultsSlice";
import { ViewerClosedWorkflowHeaders } from "../ViewerColumnHeader/ViewerClosedWorkflowHeaders";
import { ViewerPendingActionHeaders } from "../ViewerColumnHeader/ViewerPendingActionHeaders";
import { ViewerPendingApprovalHeaders } from "../ViewerColumnHeader/ViewerPendingApprovalHeaders";
import OutBoundDataModal from '../OutBound/OutBoundDataModal';
import CPLeadTimeModal from '../ContractPIRLeadTimeModal/CPLeadTimeModal';
import { VariantViewModal } from '../VariantView/VariantViewModal';
import { ShowVariantViewModal } from '../VariantView/ShowVariantViewModal';

const ViewerAnalyticsResults = () => {
  const role = localStorage.getItem("LTRole");
  const userEmail = localStorage.getItem("data");
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const [rowData, setRowData] = useState([]);
  const [activeItem, setActiveItem] = useState(localStorage.getItem("workflowActiveItem") || "Pending Action");
  const [filteredData, setFilteredData] = useState([]);
  const { state } = useLocation();
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState();
  const [openViewAllModal, setOpenViewAllModal] = useState(false);
  const [viewAllData, setViewAllData] = useState({});
  const [countValue, setCountValue] = useState();

  const [pageSize, setPageSize] = useState(500);
  const [currentPage, setCurrentPage] = useState(Number(localStorage.getItem("lastVisitedPage")) || 1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPageItems, setTotalPageItems] = useState(0);
  const [totalItemCurrentPage, setTotalItemCurrentPage] = useState(0);

  const [columnFilterDropdownOption, setColumnFilterDropdownOption] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [badgeCount, setBadgeCount] = useState();
  const [openOutboundModal, setOpenOutboundModal] = useState(false);
  const [outboundData, setOutboundData] = useState({});
  const [selectedName, setSelectedName] = useState("");
  const [openCreateVariantModal, setOpenCreateVariantModal] = useState(false);
  const [openShowVariantModal, setOpenShowVariantModal] = useState(false);
  const [variantData, setVariantData] = useState({});
  const savedFilterModel = localStorage.getItem("savedVariantFilterModel");

  const [leadTimeName, setLeadTimeName] = useState("");
  const [openLeadTimeModal, setOpenLeadTimeModal] = useState(false);
  const [leadTimeData, setLeadTimeData] = useState({});

  const [disableFilterBtn, setDisableFilterBtn] = useState(true);

  const landingCardTitle = state || "High LT Variation";
  const variationRanking = landingCardTitle === "Medium LT Variation" ? { "High": 3, "Medium": 2, "Low": 1 } : landingCardTitle === "Low LT Variation" ? { "High": 2, "Medium": 1, "Low": 3 } : { "High": 3, "Medium": 2, "Low": 1 };

  useEffect(() => {
    getWorkFlowCount();
    getWorkFlowData(activeItem === "Pending Action" ? "pendingActionItems" : activeItem === "Pending Approval" ? "pendingApprovalItems" : "closedWorkflowItems");
  }, [currentPage, pageSize])

  const getWorkFlowCount = async () => {
    try {
      const responseCount = await dispatch(getViewerWorkFlowCountSlice({
        dynamicEndpoint: `${viewerWorkflowCountEndpoint}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseCount?.meta?.requestStatus === 'fulfilled') {
        gridApi?.deselectAll();
        setCountValue(responseCount?.payload);
        checkVariantFilter();
      } else {
        console.error('Failed to fetch data:', responseCount?.error);
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  const checkVariantFilter = () => {
    if (!gridApi) return;

    if (savedFilterModel) {
      try {
        const parsedFilterModel = JSON.parse(savedFilterModel);
        gridApi.setFilterModel(parsedFilterModel);
        gridApi.onFilterChanged();
      } catch (e) {
        console.error("Error parsing saved filter model:", e);
      }
    }
  }
  const getWorkFlowData = async (endpoint) => {
    try {
      const responseAnaltics = await dispatch(getViewerAnalyticsWorkflowResults({
        dynamicEndpoint: `api/lt/viewer/${endpoint}`,
        params: {
          page: currentPage,
          size: pageSize,
          plant: localStorage.getItem("selectedLTPlantCode")
        },
      }));
      if (responseAnaltics?.meta?.requestStatus === 'fulfilled') {
        gridApi?.deselectAll();
        setRowData(responseAnaltics?.payload?.records);
        getFilterUpdateData(responseAnaltics?.payload?.records)
        setTotalPages(responseAnaltics?.payload?.totalPages);
        setTotalPageItems(responseAnaltics?.payload?.totalNumberOfItems);
        setTotalItemCurrentPage(responseAnaltics?.payload?.totalItemsInPage);
      } else {
        console.error('Failed to fetch data:', responseAnaltics?.error);
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const getFilterUpdateData = (data) => {
    const mapRow = (row, index) => {
      const finalLt =
        row.recomConfidenceLevel === "75%"
          ? row.likelyFinalLt || 0
          : row.recomConfidenceLevel === "65%"
            ? row.lessLikelyFinalLt || 0
            : row.highLikelyFinalLt || 0;

      const currLt = Number(
        row?.purchDocType === "Y1"
          ? row?.contractLt?.split(" ")[0]
          : row?.activePirLt?.split(" ")[0]
      );

      const ratio = Math.sqrt(Number(finalLt) / currLt);
      const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

      const inventoryChange =
        (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
        row?.currentAvgStock;

      let inventoryValue = ((row?.actualPrice || 0) * inventoryChange).toFixed(2);

      return {
        ...row,
        finalLt,
        potentialImpact,
        inventoryValue,
        index,
      };
    };

    if (activeItem === "Pending Action") {
      const sortedFilterData = data
        ?.map(mapRow)
        ?.sort((a, b) => variationRanking[b.ltVariations] - variationRanking[a.ltVariations]);
      setFilteredData(sortedFilterData);
    }
    if (activeItem === "Pending Approval") {
      setFilteredData(data?.map(mapRow));
    }
    if (activeItem === "Closed Workflow Items") {
      setFilteredData(data?.map(mapRow));
    }
  }

  const navigate = useNavigate();

  const onGridReady = (params) => {
    setGridApi(params?.api);
    gridRef.current = params?.api;
  }
  const getAdminHideColumnsData = async () => {
    try {
      const responseHideAdminData = await dispatch(getViewerHideColumnsAPI({
        dynamicEndpoint: `${getLTViewerHideColumnsEndpoint}/${userEmail}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseHideAdminData?.meta?.requestStatus === 'fulfilled') {
        setSelectedColumns(responseHideAdminData?.payload);
        setBadgeCount(responseHideAdminData?.payload?.length);
        const hideDropdownOptions = regularItemsData?.filter((item) => item?.optionalField === true);
        setColumnFilterDropdownOption(hideDropdownOptions);
        const displayedColumns = regularItemsData.filter(
          col => !col.optionalField || !responseHideAdminData?.payload?.includes(col.headerName)
        );
        setFilteredColumnsData([...displayedColumns]);
      } else {
        console.error('Failed to fetch data:', responseHideAdminData?.error);
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  useEffect(() => {
    getAdminHideColumnsData()

  }, [])

  const onChangeConfidenceLevel = (params) => {
    // console.log("Entered ", params);
  }

  const cellEditorParams = {
    getPopUpPosition: () => "under",
    popup: true,
    editorStyle: {
      width: "60px"
    }

  }
  const getViewAllData = async (row) => {
    try {
      const responseViewAllDetails = await dispatch(getViewAllDetails({
        dynamicEndpoint: `${getViewAllDetailsEndpoint}/${row.runSeqId}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
        setViewAllData(responseViewAllDetails?.payload)
      } else {
        console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
        setViewAllData({})
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  const handleOpenViewAllModal = (row) => {
    setOpenViewAllModal(true);
    getViewAllData(row);
  }
  const handleCloseViewAllModal = (row) => {
    setOpenViewAllModal(false);
    setViewAllData({})
  }

  const handleOpenOutboundModal = (row, name) => {
    setOpenOutboundModal(true);
    setOutboundData(row);
    setSelectedName(name)
  }
  const handleCloseOutboundModal = (row) => {
    setOpenOutboundModal(false);
    setOutboundData({});
  }

  const handleOpenLeadTime = (row, name) => {
    setOpenLeadTimeModal(true);
    setLeadTimeData(row);
    setLeadTimeName(name)
  }
  const handleCloseLeadTime = (row) => {
    setOpenLeadTimeModal(false);
    setLeadTimeData({});
  }

  const regularItemsData = activeItem === "Pending Action" ? ViewerPendingActionHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenLeadTime) : activeItem === "Pending Approval" ? ViewerPendingApprovalHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenLeadTime) : ViewerClosedWorkflowHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenOutboundModal, handleOpenLeadTime)
  const [filteredColumnsData, setFilteredColumnsData] = useState(regularItemsData);
  useEffect(() => {
    getAdminHideColumnsData();
  }, [activeItem]);

  const cardData = [
    { title: "Pending Action", value: countValue?.pendingActionCount },
    { title: "Pending Approval", value: countValue?.pendingApprovalCount },
    { title: "Closed Workflow Items", value: countValue?.closedWorkflowCount },
  ];
  const callBackFunction = (index, title, url) => {
    setActiveItem(title);
    // clearAllFilters();
    getWorkFlowCount();
    if (title === "Pending Action") {
      setPageSize(500);
      setCurrentPage(1)
      localStorage.setItem("lastVisitedPage", 1);
      getWorkFlowData("pendingActionItems");
    }
    if (title === "Pending Approval") {
      setPageSize(500);
      setCurrentPage(1)
      localStorage.setItem("lastVisitedPage", 1);
      getWorkFlowData("pendingApprovalItems");
    }
    if (title === "Closed Workflow Items") {
      setPageSize(500);
      setCurrentPage(1)
      localStorage.setItem("lastVisitedPage", 1);
      getWorkFlowData("closedWorkflowItems");
    }
    localStorage.setItem("workflowActiveItem", title);
  }

  const selectionColumnDef = useMemo(() => ({
    pinned: 'left'
  }))

  const clearAllFilters = () => {
    if (gridRef.current) {
      gridRef.current.setFilterModel(null);
      setDisableFilterBtn(true);
    }
    localStorage.removeItem("savedVariantFilterModel");
  };

  const onFilterChanged = () => {
    if (gridRef.current) {
      const filterModel = gridRef.current.getFilterModel();
      setDisableFilterBtn(Object.keys(filterModel).length === 0);
    }
  };

  const gridOptions = {
    getRowId: (params) => {
      return `${params?.data?.index}`
    },
    onFilterChanged,
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressMiniFilter: false,
            },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: {
              excelMode: 'windows',
              suppressMiniFilter: false,
              buttons: ['apply', 'reset'],
            },
          },
        ],
      },
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
        if (!params.data) return "-";

        const field = params.colDef.field;
        const value = params.data[field];

        return value === null || value === undefined || value === "" ? "-" : value;
      },
    }

  }
  useEffect(() => {
    checkVariantFilter()
  }, [gridApi]);

  const handleCreateVariantModal = () => {
    setVariantData(gridApi?.getFilterModel());
    setOpenCreateVariantModal(true);
  }

  const handleCloseCreateVariantModal = () => {
    setOpenCreateVariantModal(false)
  }
  const handleShowVariantModal = () => {
    setOpenShowVariantModal(true);
  }

  const handleCloseShowVariantModal = () => {
    setOpenShowVariantModal(false)
  }
  const onClickSelectVariant = (variant) => {
    if (!gridApi || !variant?.filterJson) return;

    try {
      const filterModel =
        typeof variant.filterJson === "string"
          ? JSON.parse(variant.filterJson)
          : variant.filterJson;

      localStorage.setItem("savedVariantFilterModel", JSON.stringify(filterModel));
      gridApi.setFilterModel(filterModel);
      gridApi.onFilterChanged();
    } catch (e) {
      console.error("Invalid filterJson:", variant.filterJson, e);
    }
  };

  const onPageSizeChanged = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      localStorage.setItem("lastVisitedPage", page);
    }
  };

  const getRange = () => {
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalPageItems);
    return `${start} - ${end}`
  }

  const handleColumnChange = (event) => {
    setSelectedColumns(event.target.value);
  };

  const renderDropdownValue = (selected) => {
    if (selected?.length === 0) return "Select Columns";
    if (selected?.length === 1) return columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;

    const firstColumnName = columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;
    return `${firstColumnName}, +${selected?.length - 1}`;
  };

  const handleSave = async () => {

    const responseBody = {
      "userEmail": userEmail,
      "hiddenColumns": selectedColumns
    }

    try {
      const responsePostAdminHideColumns = await dispatch(postViewerHideColumnsAPI({
        dynamicEndpoint: `${postLTViewerHideColumnsEndpoint}`,
        data: responseBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responsePostAdminHideColumns?.meta?.requestStatus === 'fulfilled') {
        getAdminHideColumnsData();
        handleCloseHide();
      } else {
        console.error('Failed to fetch data:', responsePostAdminHideColumns?.error);
      }
    } catch (error) {
      console.error('API error:', error);
    }

    const displayedColumns = regularItemsData.filter(
      col => !col.optionalField || !selectedColumns.includes(col.headerName)
    );
    setFilteredColumnsData([...displayedColumns]);
  }

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickHide = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseHide = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    (stateSelector?.GetWorkflowCountSlice?.loading || stateSelector?.AnalyticsWorkflowResultsSlice?.loading) ?
      <Loader />
      :
      <div>
        <TopSection tabTitle="Workflow Management" labelList={[{ title: 'Home', path: '/landing-page' }, { title: 'Analytics Results' }]} />
        <div className="card_container">
          <Cards cards={cardData} showBorder={true} callBackFunction={callBackFunction} />
        </div>
        <div><p id="activeItem_Workflow">{activeItem}</p></div>
        <div
          style={{
            border: "1px solid lightgrey",
            borderRadius: "6px",
            padding: "10px",
          }}
        >

          <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '5px 0px 10px 0px' }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <div style={{ display: 'flex', gap: 10 }}>
                <IconButton onClick={handleClickHide}>
                  <Badge badgeContent={badgeCount > 0 ? badgeCount : null} sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.6rem", // Smaller font size
                      height: "16px", // Adjust badge height
                      minWidth: "16px", // Adjust badge width
                      padding: "4px", // Adjust padding
                      background: '#000',
                      color: '#fff'
                    },
                  }}
                  >
                    <MoreVertIcon />
                  </Badge>
                </IconButton>
                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleCloseHide}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  className="hidePopover"
                  sx={{
                    marginTop: 1,
                    marginLeft: 0,
                  }}
                >
                  <div style={{ padding: 10, width: 150 }}>
                    <p style={{ marginBottom: 10, marginTop: 5 }}>Hide Columns</p>
                    <Select
                      multiple
                      value={selectedColumns}
                      onChange={handleColumnChange}
                      renderValue={renderDropdownValue}
                      displayEmpty
                      sx={{ backgroundColor: "#fff", border: '1px solid #000', width: '100%', height: 35, marginBottom: 5 }}
                    >
                      <MenuItem disabled value="">
                        <em>Select Columns</em>
                      </MenuItem>
                      {columnFilterDropdownOption.map(col => (
                        <MenuItem key={col.headerName} value={col.headerName}>
                          <Checkbox checked={selectedColumns.includes(col.headerName)} />
                          <ListItemText primary={col.headerName} />
                        </MenuItem>
                      ))}

                    </Select>
                    {stateSelector?.PostAdminHideColumns?.loading ?
                      <Box style={{ textAlign: 'center' }}>
                        <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center' }} />
                      </Box>
                      :
                      <ButtonComponent type="secondary" label="Save" onClick={handleSave} />
                    }
                  </div>
                </Popover>
              </div>
              <div style={{ display: 'flex', justifyContent: 'end', gap: 10 }}>
                <ButtonComponent
                  maxWidth="150px"
                  label="Clear All Filters"
                  bgColor="black"
                  color="white"
                  disabled={disableFilterBtn}
                  onClick={clearAllFilters}
                />
                <ButtonComponent
                  maxWidth="180px"
                  label="Create/Edit Variant"
                  bgColor="black"
                  color="white"
                  // disabled={Object.keys(gridApi?.getFilterModel() || {}).length === 0}
                  onClick={handleCreateVariantModal}
                />
                <ButtonComponent
                  maxWidth="150px"
                  label="Show Variants"
                  bgColor="black"
                  color="white"
                  onClick={handleShowVariantModal}
                />
              </div>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {filteredData &&
              <div>
                <DataTable
                  ref={gridRef}
                  columns={filteredColumnsData}
                  rows={filteredData || []}
                  paginationProp={false}
                  onGridReady={onGridReady}
                  selectionColumnDef={selectionColumnDef}
                  gridOptions={gridOptions}
                  cellEditorParams={cellEditorParams}
                />

                <div className="customPagination_admin">
                  <div className="pagSize_pagination_Admin">
                    <p style={{ margin: '5px' }}>Page Size:</p>
                    <select onChange={onPageSizeChanged} value={pageSize} style={{ width: '70px', borderRadius: '5px', borderColor: 'lightgray', padding: '5px' }}>
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <div style={{ margin: '0 25px' }}>
                    <span>{`${getRange()} of ${totalPageItems}`}</span>
                  </div>
                  <div>
                    <IconButton onClick={() => goToPage(1)} disabled={currentPage === 1} style={{ padding: 0 }}>
                      <SkipPreviousIcon />
                    </IconButton>
                    <IconButton onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                      <ArrowLeftIcon />
                    </IconButton>
                    <span>{`Page ${currentPage} of ${totalPages}`}</span>
                    <IconButton onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
                      <ArrowRightIcon />
                    </IconButton>
                    <IconButton onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages} style={{ padding: 0 }}>
                      <SkipNextIcon />
                    </IconButton>
                  </div>
                </div></div>}
            <div>
              <VariantViewModal tableType={"LT_VIEWER"} openCreateVariantModal={openCreateVariantModal} handleCloseCreateVariantModal={handleCloseCreateVariantModal} data={variantData} />
            </div>
            <div>
              <ShowVariantViewModal tableType={"LT_VIEWER"} openShowVariantModal={openShowVariantModal} handleCloseShowVariantModal={handleCloseShowVariantModal} data={variantData} onClickSelectVariant={onClickSelectVariant} />
            </div>
            <div>
              <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
            </div>
            <div>
              <OutBoundDataModal data={outboundData} selectedName={selectedName} openOutboundModal={openOutboundModal} handleCloseOutboundModal={handleCloseOutboundModal} />
            </div>
            <div>
              <CPLeadTimeModal data={leadTimeData} leadTimeName={leadTimeName} openLeadTimeModal={openLeadTimeModal} handleCloseLeadTime={handleCloseLeadTime} />
            </div>
          </div>
        </div>
      </div >
  );
};

export default ViewerAnalyticsResults;
